import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { getTheme, toggleTheme, onTheme } from "@/lib/theme";

export default function ThemeToggle({ className = "" }) {
    const [theme, setTheme] = useState(getTheme());
    useEffect(() => onTheme(setTheme), []);
    const dark = theme === "dark";
    return (
        <button
            data-testid="theme-toggle"
            onClick={() => toggleTheme()}
            aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
            title={dark ? "Light mode" : "Dark mode"}
            className={`w-9 h-9 rounded-full border border-line flex items-center justify-center text-mist hover:text-copper hover:border-copper transition-colors duration-300 ${className}`}
        >
            {dark ? <Sun size={15} /> : <Moon size={15} />}
        </button>
    );
}
